// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"Preview__previewContainer--rm","preview":"Preview__preview--BR","brush":"Preview__brush--S2","victoryContainer":"Preview__victoryContainer--wd"};